import { styled } from '../../../hooks/theme';
import { Tokens } from '../../../types';

export const Container = styled.div`
  width: 100%;
  height: 64px;

  margin-top: calc(53px * 5px);

  font-family: ${props => props.theme.font.family.sans};
  border-radius: 0px 0px 8px 8px;

  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
Container.defaultProps = {
  theme: Tokens.eixods,
};

export const TakeContainer = styled.div``;

export const TakeSelector = styled.div`
  position: relative;
  width: 38px;
  padding: 5px;

  background: ${props => props.theme.colors.neutral.grey[0]};

  display: flex;
  align-items: center;
  justify-content: space-between;

  cursor: pointer;

  img {
    width: 18px;
  }

  &:hover {
    background: ${props => props.theme.colors.neutral.grey[5]};
    box-shadow: 0px 2px 12px 2px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.06);
  }
`;
TakeSelector.defaultProps = {
  theme: Tokens.eixods,
};

export const TakeDropdown = styled.div`
  position: absolute;
  top: 28px;
  left: 0;

  z-index: inherit;

  box-shadow: 0px 2px 12px 2px rgba(0, 0, 0, 0.04);

  display: flex;
  flex-direction: column;
`;

export const TakeButton = styled.button`
  width: 48px;
  height: 26px;

  border: none;
  background: ${props => props.theme.colors.neutral.grey[5]};
  cursor: pointer;

  &:hover {
    background: ${props => props.theme.colors.neutral.grey[10]};
  }
`;
TakeButton.defaultProps = {
  theme: Tokens.eixods,
};

export const PaginationInfo = styled.div``;

export const Paginator = styled.div`
  margin-top: 3px;

  display: flex;
  align-items: center;

  img {
    height: 18px;
    cursor: pointer;
  }

  img:hover {
    background: ${props => props.theme.colors.neutral.grey[10]};
  }
`;
Paginator.defaultProps = {
  theme: Tokens.eixods,
};
